// src/Common/Forms/Enums/TargetEnum.cs

export enum FormType {
  Intake = "intake",
}
